import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle, RefreshCw } from 'lucide-react';
import { SIZE_ERROR_MESSAGE } from '../infrastructure/videoInterviewService';

export default function VideoInterviewFailurePage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const returnUrl = searchParams.get('returnUrl') || '/';
    const error = searchParams.get('error');
    const isSizeError = searchParams.get('kind') === 'size';
    const message = isSizeError ? SIZE_ERROR_MESSAGE : error;

    return (
        <div className="min-h-screen bg-muted flex flex-col items-center justify-center p-6">
            <div className="bg-card rounded-2xl shadow-xl p-8 max-w-md w-full text-center border border-border">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <XCircle className="w-10 h-10 text-red-600" />
                </div>

                <h1 className="text-2xl font-bold text-foreground mb-2">Submission Failed</h1>
                <p className="text-muted-foreground mb-8 leading-relaxed">
                    {message || "We encountered an issue while uploading your video interview. Please check your internet connection and try again."}
                </p>

                <button
                    onClick={() => navigate(returnUrl)}
                    className="w-full flex items-center justify-center gap-2 bg-gray-900 hover:bg-gray-800 text-white py-3 px-6 rounded-xl font-semibold transition-all"
                >
                    <RefreshCw className="w-5 h-5" />
                    {isSizeError ? "Record again" : "Try Again"}
                </button>
            </div>
        </div>
    );
}
